/* eslint-disable */
import { envDomain } from '@/common/contact-selector/utils/domainConfig';
import convertList from '../convertList';
import filters from '../filters';

function getTroopDetail(params) {
    return Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/b2b/selector/getTroopDetail`, params);
}

function getList() {
    return new Promise((resolve, reject) => {
        qdp.getGroupList({
            success(res) {
                const config = res;
                const groupList = res.groupList || [];
                config.filter = 0;
                const groupCount = groupList.reduce((result, item) => {
                    return result + (item.groupCode || []).length;
                }, 0);
                if (groupCount) {
                    getTroopDetail(config).then(
                        resdata => {
                            resolve(resdata);
                        },
                        err => {
                            reject(err);
                        }
                    );
                } else {
                    resolve([]);
                }
            },
            fail(res) {
                reject(res);
            }
        });
    });
}

export default function(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        getList().then(
            res => {
                if (res.data.records && res.data.records.length) {
                    let list = res.data.records;
                    list = filters.filterTroopList(list, selfConfig);
                    list = list.map(x => {
                        return {
                            ...x,
                            loaded: true,
                            id: `${x.uin}`,
                            uin: `${x.uin}`
                        };
                    });
                    // const merConfig = Object.assign(config, moreConfig);

                    const cList = convertList(list, {
                        list: 'groupList',
                        groupName: 'groupName'
                    });

                    resolve(cList);
                } else {
                    resolve([]);
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
